import type { AfterViewInit, OnInit } from '@angular/core';
import { Component, HostListener, inject } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { ErrorNavigationService } from '../../mega-exchange/services/error-navigation.service';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';
import { FmLoadingPageService } from '../../shared/services/fm-loading-page.service';

@Component({
  standalone: false,
  selector: 'invd-error-500',
  templateUrl: './error-500.component.html',
  styleUrls: ['./error-500.component.scss'],
})
export class Error500Component implements OnInit, AfterViewInit {
  public displayMessage = '';
  public displayResolution = '';
  public displayErrorCode = '';
  public showStaticMessage = true;
  private isAllowToNavigateAway: boolean;

  private errorObj: any;

  private errorHandlerService = inject(ErrorHandlerService);
  private errorNavService = inject(ErrorNavigationService);
  private router = inject(Router);
  private fmLoadingPageService = inject(FmLoadingPageService);

  @HostListener('window:popstate', ['$event'])
  reloadApp(_$event) {
    window.location.href =
      window.location.protocol + '//' + window.location.hostname + window.location.pathname;
  }

  ngOnInit() {
    this.fmLoadingPageService.isLoaderRequesting.set(false);
    if (
      this.errorHandlerService.getErrorObj() !== null &&
      this.errorHandlerService.getErrorObj() !== undefined &&
      this.errorHandlerService.getErrorObj().error
    ) {
      this.errorObj = this.errorHandlerService.getErrorObj().error;
      if (
        this.errorObj !== null &&
        this.errorObj.messages !== null &&
        this.errorObj.messages !== undefined
      ) {
        this.showStaticMessage = false;
        this.errorObj = this.errorObj.messages[0];
        this.displayMessage = this.errorObj.errorMessage;
        this.displayResolution = this.errorObj && this.errorObj.displayResolution;
        this.displayErrorCode = this.errorObj.messageCode;
      } else {
        this.showStaticMessage = true;
      }
    } else {
      this.showStaticMessage = true;
    }
    this.errorNavService.navigateToError500 = false;
  }

  ngAfterViewInit() {
    this.navigationController();
  }

  private navigationController() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (event.url.indexOf('enter-details') > 0) {
          this.isAllowToNavigateAway = false;
        } else {
          this.isAllowToNavigateAway = true;
        }
        window.scrollTo(0, 0);
      }
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }

  canDeactivate(): Promise<boolean> | boolean {
    return this.isAllowToNavigateAway;
  }

  public megaHomeButtonClicked(): void {
    const currentUrl =
      window.location.protocol + '//' + window.location.hostname + window.location.pathname;
    window.location.href = currentUrl;
  }
}
